(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Tab-product12"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      tab.classList.add('active');
      document.getElementById(tab.dataset.contentId).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-showcase"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function() {
        const slider = document.getElementById('psSlider');
        if (!slider) return;

        const slides = slider.querySelectorAll('.ps-slide');
        const dots = slider.querySelectorAll('.ps-dot');
        if (slides.length === 0) return;

        let currentIndex = slides.length > 2 ? 2 : 0;
        let isMouseDown = false;
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let distX = 0;
        let distY = 0;

        slider.style.cursor = 'grab';

        function updateSlider(index) {
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;

          slides.forEach((slide, i) => {
            slide.className = 'ps-slide';
            let diff = i - index;
            if (diff < -2) diff += slides.length;
            if (diff > 2) diff -= slides.length;

            if (diff === 0) slide.classList.add('active');
            else if (diff === -1) slide.classList.add('prev');
            else if (diff === 1) slide.classList.add('next');
            else if (diff === -2) slide.classList.add('far-prev');
            else if (diff === 2) slide.classList.add('far-next');
          });

          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
          });
          currentIndex = index;
        }

        slides.forEach((slide, index) => {
          slide.addEventListener('click', (e) => {
            if (isDragging || Math.abs(distX) > 10) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            if (slide.classList.contains('prev') || slide.classList.contains('next') ||
                slide.classList.contains('far-prev') || slide.classList.contains('far-next')) {
              e.preventDefault();
              updateSlider(index);
            }
          });
        });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => updateSlider(index));
        });

        /* ── Mouse Drag & Touch Swipe Support ─────────────────────────── */
        function onStart(e) {
          isMouseDown = true;
          isDragging = false;
          const clientX = e.touches ? e.touches[0].clientX : e.clientX;
          const clientY = e.touches ? e.touches[0].clientY : e.clientY;
          startX = clientX;
          startY = clientY;
          distX = 0;
          distY = 0;
          if (!e.touches) {
            slider.style.cursor = 'grabbing';
          }
        }

        function onMove(e) {
          if (!isMouseDown) return;
          const clientX = e.touches ? e.touches[0].clientX : e.clientX;
          const clientY = e.touches ? e.touches[0].clientY : e.clientY;
          distX = clientX - startX;
          distY = clientY - startY;

          if (Math.abs(distX) > 10 && Math.abs(distX) > Math.abs(distY)) {
            isDragging = true;
          }
        }

        function onEnd(e) {
          if (!isMouseDown) return;
          isMouseDown = false;
          if (!e.touches) {
            slider.style.cursor = 'grab';
          }

          if (Math.abs(distX) > 30 && Math.abs(distX) > Math.abs(distY)) {
            if (distX < 0) {
              updateSlider(currentIndex + 1);
            } else {
              updateSlider(currentIndex - 1);
            }
          }

          setTimeout(() => {
            isDragging = false;
            startX = 0;
            startY = 0;
            distX = 0;
            distY = 0;
          }, 100);
        }

        slider.addEventListener('mousedown', onStart);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);

        slider.addEventListener('touchstart', onStart, { passive: true });
        slider.addEventListener('touchmove', onMove, { passive: true });
        slider.addEventListener('touchend', onEnd);
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skincare-grid"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function() {
        const wrapper = document.querySelector('#psSlider');
        if (!wrapper) return;

        const slides = wrapper.querySelectorAll('.ps-slide');
        const dots = wrapper.querySelectorAll('.ps-dot');
        if (slides.length === 0) return;

        let currentIndex = slides.length > 2 ? 2 : 0;
        let isMouseDown = false;
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let distX = 0;
        let distY = 0;

        wrapper.style.cursor = 'grab';

        function updateSlider(index) {
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;

          slides.forEach((slide, i) => {
            slide.className = 'ps-slide';
            let diff = i - index;
            if (diff < -2) diff += slides.length;
            if (diff > 2) diff -= slides.length;

            if (diff === 0) slide.classList.add('active');
            else if (diff === -1) slide.classList.add('prev');
            else if (diff === 1) slide.classList.add('next');
            else if (diff === -2) slide.classList.add('far-prev');
            else if (diff === 2) slide.classList.add('far-next');
          });

          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
          });
          currentIndex = index;
        }

        slides.forEach((slide, index) => {
          slide.addEventListener('click', function(e) {
            if (isDragging || Math.abs(distX) > 10) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            if (!slide.classList.contains('active')) {
              e.preventDefault();
              updateSlider(index);
            }
          });
        });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => updateSlider(index));
        });

        // Mouse Drag & Touch Swipe handling
        function onStart(e) {
          isMouseDown = true;
          isDragging = false;
          const clientX = e.touches ? e.touches[0].clientX : e.clientX;
          const clientY = e.touches ? e.touches[0].clientY : e.clientY;
          startX = clientX;
          startY = clientY;
          distX = 0;
          distY = 0;
          if (!e.touches) {
            wrapper.style.cursor = 'grabbing';
          }
        }

        function onMove(e) {
          if (!isMouseDown) return;
          const clientX = e.touches ? e.touches[0].clientX : e.clientX;
          const clientY = e.touches ? e.touches[0].clientY : e.clientY;
          distX = clientX - startX;
          distY = clientY - startY;

          if (Math.abs(distX) > 10 && Math.abs(distX) > Math.abs(distY)) {
            isDragging = true;
          }
        }

        function onEnd(e) {
          if (!isMouseDown) return;
          isMouseDown = false;
          if (!e.touches) {
            wrapper.style.cursor = 'grab';
          }

          if (Math.abs(distX) > 30 && Math.abs(distX) > Math.abs(distY)) {
            if (distX < 0) {
              updateSlider(currentIndex + 1);
            } else {
              updateSlider(currentIndex - 1);
            }
          }

          setTimeout(() => {
            isDragging = false;
            startX = 0;
            startY = 0;
            distX = 0;
            distY = 0;
          }, 100);
        }

        wrapper.addEventListener('mousedown', onStart);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);

        wrapper.addEventListener('touchstart', onStart, { passive: true });
        wrapper.addEventListener('touchmove', onMove, { passive: true });
        wrapper.addEventListener('touchend', onEnd);
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-economy-1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.economy-accordions-item-title');

    accordionItems.forEach(item => {
      item.addEventListener('click', function() {
        const parent = this.parentElement;
        const content = this.nextElementSibling;
        const icon = this.querySelector('.accordion-icon');
        const isActive = parent.classList.contains('is-active');
        const container = parent.closest('.economy-accordions');

        // Close all other items in the same box
        container.querySelectorAll('.economy-accordions-item').forEach(otherItem => {
          otherItem.classList.remove('is-active');
          otherItem.querySelector('.economy-accordions-item-detail').style.display = 'none';
          otherItem.querySelector('.accordion-icon').textContent = '+';
        });

        // Toggle clicked item
        if (!isActive) {
          parent.classList.add('is-active');
          content.style.display = 'block';
          icon.textContent = '-';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-economy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.economy-accordions-item-title');

    accordionItems.forEach(item => {
      item.addEventListener('click', function() {
        const parent = this.parentElement;
        const content = this.nextElementSibling;
        const icon = this.querySelector('.accordion-icon');
        const isActive = parent.classList.contains('is-active');

        // Close all other items
        document.querySelectorAll('.economy-accordions-item').forEach(otherItem => {
          otherItem.classList.remove('is-active');
          otherItem.querySelector('.economy-accordions-item-detail').style.display = 'none';
          otherItem.querySelector('.accordion-icon').textContent = '+';
        });

        // Toggle clicked item
        if (!isActive) {
          parent.classList.add('is-active');
          content.style.display = 'block';
          icon.textContent = '-';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplements-grid"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function() {
        const wrapper = document.querySelector('#psSlider');
        if (!wrapper) return;

        const slides = wrapper.querySelectorAll('.ps-slide');
        const dots = wrapper.querySelectorAll('.ps-dot');
        if (slides.length === 0) return;

        let currentIndex = slides.length > 2 ? 2 : 0;
        let isMouseDown = false;
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let distX = 0;
        let distY = 0;

        wrapper.style.cursor = 'grab';

        function updateSlider(index) {
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;

          slides.forEach((slide, i) => {
            slide.className = 'ps-slide';
            let diff = i - index;
            if (diff < -2) diff += slides.length;
            if (diff > 2) diff -= slides.length;

            if (diff === 0) slide.classList.add('active');
            else if (diff === -1) slide.classList.add('prev');
            else if (diff === 1) slide.classList.add('next');
            else if (diff === -2) slide.classList.add('far-prev');
            else if (diff === 2) slide.classList.add('far-next');
          });

          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
          });
          currentIndex = index;
        }

        slides.forEach((slide, index) => {
          slide.addEventListener('click', function(e) {
            if (isDragging || Math.abs(distX) > 10) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            if (!slide.classList.contains('active')) {
              e.preventDefault();
              updateSlider(index);
            }
          });
        });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => updateSlider(index));
        });

        // Mouse Drag & Touch Swipe handling
        function onStart(e) {
          isMouseDown = true;
          isDragging = false;
          const clientX = e.touches ? e.touches[0].clientX : e.clientX;
          const clientY = e.touches ? e.touches[0].clientY : e.clientY;
          startX = clientX;
          startY = clientY;
          distX = 0;
          distY = 0;
          if (!e.touches) {
            wrapper.style.cursor = 'grabbing';
          }
        }

        function onMove(e) {
          if (!isMouseDown) return;
          const clientX = e.touches ? e.touches[0].clientX : e.clientX;
          const clientY = e.touches ? e.touches[0].clientY : e.clientY;
          distX = clientX - startX;
          distY = clientY - startY;

          if (Math.abs(distX) > 10 && Math.abs(distX) > Math.abs(distY)) {
            isDragging = true;
          }
        }

        function onEnd(e) {
          if (!isMouseDown) return;
          isMouseDown = false;
          if (!e.touches) {
            wrapper.style.cursor = 'grab';
          }

          if (Math.abs(distX) > 30 && Math.abs(distX) > Math.abs(distY)) {
            if (distX < 0) {
              updateSlider(currentIndex + 1);
            } else {
              updateSlider(currentIndex - 1);
            }
          }

          setTimeout(() => {
            isDragging = false;
            startX = 0;
            startY = 0;
            distX = 0;
            distY = 0;
          }, 100);
        }

        wrapper.addEventListener('mousedown', onStart);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);

        wrapper.addEventListener('touchstart', onStart, { passive: true });
        wrapper.addEventListener('touchmove', onMove, { passive: true });
        wrapper.addEventListener('touchend', onEnd);
      });
    
  } catch(e) { console.error(e); }
})();
})();
